import { VoucherType } from '../types/voucher.types';

export const getDiscountTypeFromVoucherType = (voucherType: string): string => {
  const typeNumber = parseInt(voucherType);
  switch (typeNumber) {
    case VoucherType.Credits:
      return 'additional';
    case VoucherType.DiscountFixed:
      return 'fixed';
    case VoucherType.DiscountCap:
      return 'percentage';
    default:
      return 'additional';
  }
};

export const getVoucherTypeFromDiscountType = (discountType: string): number => {
  switch (discountType) {
    case 'additional':
      return VoucherType.Credits;
    case 'fixed':
      return VoucherType.DiscountFixed;
    case 'percentage':
      return VoucherType.DiscountCap;
    default:
      return VoucherType.Credits;
  }
};